module.exports = __webpack_public_path__ + "static/media/Stimulate.8c7626d3.png";